import useTranslate from '../../i18n/useTranslate'
import { styled, makeStyles } from '@material-ui/core'
import MyButton from '../button/button'
import moment from 'moment'
import { FC, useEffect, useRef } from 'react'
import { saveAs } from 'file-saver'
import { asBlob } from 'html-docx-js-typescript'
import { convertDateToFormatTH } from '../../utilities/date'
import ReactHtmlParser from 'react-html-parser'
import useAppFolderAndTabStore from '../../stores/appFolderAndTab/appFolderAndTabStore'
import submittedStep from '../../constants/submittedStep'

const ButtonExport = styled(MyButton)({
    backgroundColor: '#0062FF',
    color: 'white',
})

export type CommentaryDataType = {
    nameTopicTH1: string
    nameTopicEN1: string
    nameTopicTH2: string
    nameTopicEN2: string
    comment: string
    commentHTML: string
    id: number
}

export type DatasourceForExport = {
    userID: number
    fullUsername_th: string
    fullUsername_en: string
    updatedDate: string
    updateByNameTH: string
    updateByNameEN: string
    approveStatusID: number
    approveStatusName_th: string
    approveStatusName_en: string
    commentary: CommentaryDataType[]
    historyCommentary: CommentaryDataType[]
}
export type ExportDataPropsType = {
    dataSource: DatasourceForExport[]
}

const ExportToMSWord: FC<{
    dataSource: DatasourceForExport[]
    irb: number
}> = ({ dataSource, irb }) => {
    const translate = useTranslate()
    const classes = useStyles()

    const nameLabel = useRef<string>('')
    const saveCommentDateLabel = useRef<string>('')
    const commentInsteadBy = useRef<string>('')
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const isSynthesis = appFolderAndTabStore.tabSelected?.stepID === submittedStep.synthesis

    useEffect(() => {
        nameLabel.current = translate.get('LABEL.COMMITTEE_NAME')
        saveCommentDateLabel.current = translate.get('LABEL.COMMITTEE_MEETING_DATE')
        commentInsteadBy.current = translate.get('LABEL.COMMENT_INSTEAD_BY')
    }, [translate.languageStore.currentLanguage])

    const exportToWord = async () => {
        const header = `<html><head><meta content="text/html"/><link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Prompt&display=swap" rel="stylesheet"></head><body style="font-family: 'Prompt', sans-serif;">`

        const footer = '</body></html>'

        const html = header + document.getElementById('exportData')?.innerHTML + footer
        const replaceHtml = html.replaceAll('<del>', '<s>').replaceAll('<ins>', '<u>')
        const replaceAllHtml = replaceHtml.replaceAll('</del>', '</s>').replaceAll('</ins>', '</u>')
        const blob: any = await asBlob(replaceAllHtml)
        // Specify file name
        const reportDate = moment(new Date()).format('yyyyMMDD')
        const filename = isSynthesis
            ? `ข้อคิดเห็นของผู้สังเคราะห์ความเห็น_${reportDate}.docx`
            : `ข้อคิดเห็นของคณะกรรมการ_${reportDate}.docx`

        saveAs(blob, filename)
    }

    const exportHistoryToWord = async () => {
        const header = `<html><head><meta content="text/html"><link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Prompt&display=swap" rel="stylesheet"></head><body style="font-family: 'Prompt', sans-serif;">`

        const footer = '</body></html>'

        const html = header + document.getElementById('exportHistory')?.innerHTML + footer
        const replaceHtml = html.replaceAll('<del>', '<s>').replaceAll('<ins>', '<u>')
        const replaceAllHtml = replaceHtml.replaceAll('</del>', '</s>').replaceAll('</ins>', '</u>')
        const blob: any = await asBlob(replaceAllHtml)
        // Specify file name
        const reportDate = moment(new Date()).format('yyyyMMDD')
        const filename = `ประวัติข้อคิดเห็นของคณะกรรมการ_${reportDate}.docx`

        saveAs(blob, filename)
    }

    return (
        <>
            <div id="exportData">
                <div className={classes.container}>
                    {dataSource &&
                        dataSource.map((itm, index) => {
                            return (
                                <div className={classes.spaceLine} key={index}>
                                    <div>
                                        <strong>{nameLabel.current} :</strong>{' '}
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? itm.fullUsername_th
                                            : itm.fullUsername_en}{' '}
                                        {(translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? itm.fullUsername_th
                                            : itm.fullUsername_en) !==
                                            (translate.languageStore.currentLanguage === translate.languageKey.th
                                                ? itm.updateByNameTH
                                                : itm.updateByNameEN) && (
                                            <>
                                                <strong>{commentInsteadBy.current}:</strong>{' '}
                                                {translate.languageStore.currentLanguage === translate.languageKey.th
                                                    ? itm.updateByNameTH
                                                    : itm.updateByNameEN}{' '}
                                            </>
                                        )}
                                        <strong>{saveCommentDateLabel.current} : </strong>
                                        {convertDateToFormatTH(itm.updatedDate)}{' '}
                                    </div>
                                    {itm.commentary.map((commentItm, indexComment) => {
                                        return (
                                            <>
                                                <div key={indexComment}>
                                                    {`${indexComment + 1}`}.{' '}
                                                    {irb === 1 || irb === 3
                                                        ? translate.languageStore.currentLanguage ===
                                                          translate.languageKey.th
                                                            ? commentItm.nameTopicTH1 ?? 'ข้อคิดเห็น / ข้อสังเกต'
                                                            : commentItm.nameTopicEN1 ?? 'Suggestion / Notice'
                                                        : translate.languageStore.currentLanguage ===
                                                          translate.languageKey.th
                                                        ? commentItm.nameTopicTH2 ?? 'ข้อคิดเห็น / ข้อสังเกต'
                                                        : commentItm.nameTopicEN2 ?? 'Suggestion / Notice'}{' '}
                                                    :
                                                    <br />
                                                    <div>{ReactHtmlParser(commentItm.commentHTML)}</div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    <strong>{translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :</strong>{' '}
                                    {translate.languageStore.currentLanguage === translate.languageKey.th
                                        ? itm.approveStatusName_th
                                        : itm.approveStatusName_en}
                                    <br />
                                </div>
                            )
                        })}
                </div>
            </div>

            <div id="exportHistory">
                <div className={classes.container}>
                    {dataSource &&
                        dataSource.map((itm, index) => {
                            return (
                                <div className={classes.spaceLine} key={index}>
                                    <div>
                                        <strong>
                                            ครั้งที่{' '}
                                            {itm.historyCommentary ? itm.historyCommentary[index]?.id ?? index + 1 : ''}{' '}
                                            :
                                        </strong>
                                    </div>
                                    <div>
                                        <strong>{nameLabel.current} :</strong>{' '}
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? itm.fullUsername_th
                                            : itm.fullUsername_en}{' '}
                                        {(translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? itm.fullUsername_th
                                            : itm.fullUsername_en) !==
                                            (translate.languageStore.currentLanguage === translate.languageKey.th
                                                ? itm.updateByNameTH
                                                : itm.updateByNameEN) && (
                                            <>
                                                <strong>{commentInsteadBy.current}:</strong>{' '}
                                                {translate.languageStore.currentLanguage === translate.languageKey.th
                                                    ? itm.updateByNameTH
                                                    : itm.updateByNameEN}{' '}
                                            </>
                                        )}
                                        <strong>{saveCommentDateLabel.current} : </strong>
                                        {convertDateToFormatTH(itm.updatedDate)}{' '}
                                    </div>
                                    {itm?.historyCommentary?.map((commentItm, indexComment) => {
                                        return (
                                            <>
                                                <div key={indexComment}>
                                                    {`${indexComment + 1}`}.{' '}
                                                    {irb === 1 || irb === 3
                                                        ? translate.languageStore.currentLanguage ===
                                                          translate.languageKey.th
                                                            ? commentItm.nameTopicTH1
                                                            : commentItm.nameTopicEN1
                                                        : translate.languageStore.currentLanguage ===
                                                          translate.languageKey.th
                                                        ? commentItm.nameTopicTH2
                                                        : commentItm.nameTopicEN2}{' '}
                                                    :
                                                    <br />
                                                    <div>{ReactHtmlParser(commentItm.commentHTML)}</div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    {itm?.historyCommentary?.length === 0 && (
                                        <p>ไม่มีประวัติข้อคิดเห็นของกรรมการท่านนี้</p>
                                    )}
                                    <strong>{translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :</strong>{' '}
                                    {translate.languageStore.currentLanguage === translate.languageKey.th
                                        ? itm.approveStatusName_th
                                        : itm.approveStatusName_en}
                                    <br />
                                </div>
                            )
                        })}
                </div>
            </div>
            {!isSynthesis && (
                <div className={classes.btnExport}>
                    <ButtonExport onClick={exportHistoryToWord}>
                        {translate.get('BUTTON.EXPORT_HISTORY_WORD')}
                    </ButtonExport>
                </div>
            )}
            <div className={classes.btnExport}>
                <ButtonExport onClick={exportToWord}>
                    {isSynthesis
                        ? translate.get('BUTTON.EXPORT_SYNTHESIS_WORD')
                        : translate.get('BUTTON.EXPORT_COMMENT_WORD')}
                </ButtonExport>
            </div>
        </>
    )
}

const useStyles = makeStyles(() => ({
    spaceLine: {
        marginBottom: '30px',
    },
    container: {
        zIndex: -999,
        position: 'absolute',
        opacity: 0,
    },
    btnExport: {
        padding: '10px',
        textAlign: 'end',
    },
}))

export default ExportToMSWord
